export const countryCodes = [
	"AF",
	"AX",
	"AL",
	"DZ",
	"AS",
	"AD",
	"AO",
	"AI",
	"AQ",
	"AG",
	"AR",
	"AM",
	"AW",
	"AU",
	"AT",
	"AZ",
	"BS",
	"BH",
	"BD",
	"BB",
	"BY",
	"BE",
	"BZ",
	"BJ",
	"BM",
	"BT",
	"BO",
	"BQ",
	"BA",
	"BW",
	"BV",
	"BR",
	"IO",
	"BN",
	"BG",
	"BF",
	"BI",
	"KH",
	"CM",
	"CA",
	"CV",
	"KY",
	"CF",
	"TD",
	"CL",
	"CN",
	"CX",
	"CC",
	"CO",
	"KM",
	"CG",
	"CD",
	"CK",
	"CR",
	"CI",
	"HR",
	"CU",
	"CW",
	"CY",
	"CZ",
	"DK",
	"DJ",
	"DM",
	"DO",
	"EC",
	"EG",
	"SV",
	"GQ",
	"ER",
	"EE",
	"ET",
	"FK",
	"FO",
	"FJ",
	"FI",
	"FR",
	"GF",
	"PF",
	"TF",
	"GA",
	"GM",
	"GE",
	"DE",
	"GH",
	"GI",
	"GR",
	"GL",
	"GD",
	"GP",
	"GU",
	"GT",
	"GG",
	"GN",
	"GW",
	"GY",
	"HT",
	"HM",
	"VA",
	"HN",
	"HK",
	"HU",
	"IS",
	"IN",
	"ID",
	"IR",
	"IQ",
	"IE",
	"IM",
	"IL",
	"IT",
	"JM",
	"JP",
	"JE",
	"JO",
	"KZ",
	"KE",
	"KI",
	"KP",
	"KR",
	"KW",
	"KG",
	"LA",
	"LV",
	"LB",
	"LS",
	"LR",
	"LY",
	"LI",
	"LT",
	"LU",
	"MO",
	"MK",
	"MG",
	"MW",
	"MY",
	"MV",
	"ML",
	"MT",
	"MH",
	"MQ",
	"MR",
	"MU",
	"YT",
	"MX",
	"FM",
	"MD",
	"MC",
	"MN",
	"ME",
	"MS",
	"MA",
	"MZ",
	"MM",
	"NA",
	"NR",
	"NP",
	"NL",
	"NC",
	"NZ",
	"NI",
	"NE",
	"NG",
	"NU",
	"NF",
	"MP",
	"NO",
	"OM",
	"PK",
	"PW",
	"PS",
	"PA",
	"PG",
	"PY",
	"PE",
	"PH",
	"PN",
	"PL",
	"PT",
	"PR",
	"QA",
	"RE",
	"RO",
	"RU",
	"RW",
	"BL",
	"SH",
	"KN",
	"LC",
	"MF",
	"PM",
	"VC",
	"WS",
	"SM",
	"ST",
	"SA",
	"SN",
	"RS",
	"SC",
	"SL",
	"SG",
	"SX",
	"SK",
	"SI",
	"SB",
	"SO",
	"ZA",
	"GS",
	"SS",
	"ES",
	"LK",
	"SD",
	"SR",
	"SJ",
	"SZ",
	"SE",
	"CH",
	"SY",
	"TW",
	"TJ",
	"TZ",
	"TH",
	"TL",
	"TG",
	"TK",
	"TO",
	"TT",
	"TN",
	"TR",
	"TM",
	"TC",
	"TV",
	"UG",
	"UA",
	"AE",
	"GB",
	"US",
	"UM",
	"UY",
	"UZ",
	"VU",
	"VE",
	"VN",
	"VG",
	"VI",
	"WF",
	"EH",
	"YE",
	"ZM",
	"ZW",
] as const

export type CountryCode = (typeof countryCodes)[number]

type Country = {
	code: CountryCode
	codeLowercase: Lowercase<CountryCode>
	label: string
	hasStripe?: boolean
	hasCommissions?: boolean
}
const countries: Country[] = [
	{ code: "AF", codeLowercase: "af", label: "Afghanistan" },
	{ code: "AX", codeLowercase: "ax", label: "Åland Islands" },
	{ code: "AL", codeLowercase: "al", label: "Albania" },
	{ code: "DZ", codeLowercase: "dz", label: "Algeria" },
	{ code: "AS", codeLowercase: "as", label: "American Samoa" },
	{ code: "AD", codeLowercase: "ad", label: "Andorra" },
	{ code: "AO", codeLowercase: "ao", label: "Angola" },
	{ code: "AI", codeLowercase: "ai", label: "Anguilla" },
	{ code: "AQ", codeLowercase: "aq", label: "Antarctica" },
	{ code: "AG", codeLowercase: "ag", label: "Antigua and Barbuda" },
	{ code: "AR", codeLowercase: "ar", label: "Argentina" },
	{ code: "AM", codeLowercase: "am", label: "Armenia" },
	{ code: "AW", codeLowercase: "aw", label: "Aruba" },
	{ code: "AU", codeLowercase: "au", label: "Australia", hasStripe: true, hasCommissions: true },
	{ code: "AT", codeLowercase: "at", label: "Austria", hasStripe: true, hasCommissions: true },
	{ code: "AZ", codeLowercase: "az", label: "Azerbaijan" },
	{ code: "BS", codeLowercase: "bs", label: "Bahamas" },
	{ code: "BH", codeLowercase: "bh", label: "Bahrain" },
	{ code: "BD", codeLowercase: "bd", label: "Bangladesh" },
	{ code: "BB", codeLowercase: "bb", label: "Barbados" },
	{ code: "BY", codeLowercase: "by", label: "Belarus" },
	{ code: "BE", codeLowercase: "be", label: "Belgium", hasStripe: true, hasCommissions: true },
	{ code: "BZ", codeLowercase: "bz", label: "Belize" },
	{ code: "BJ", codeLowercase: "bj", label: "Benin" },
	{ code: "BM", codeLowercase: "bm", label: "Bermuda" },
	{ code: "BT", codeLowercase: "bt", label: "Bhutan" },
	{ code: "BO", codeLowercase: "bo", label: "Bolivia, Plurinational State of" },
	{ code: "BQ", codeLowercase: "bq", label: "Bonaire, Sint Eustatius and Saba" },
	{ code: "BA", codeLowercase: "ba", label: "Bosnia and Herzegovina" },
	{ code: "BW", codeLowercase: "bw", label: "Botswana" },
	{ code: "BV", codeLowercase: "bv", label: "Bouvet Island" },
	{ code: "BR", codeLowercase: "br", label: "Brazil", hasStripe: true },
	{ code: "IO", codeLowercase: "io", label: "British Indian Ocean Territory" },
	{ code: "BN", codeLowercase: "bn", label: "Brunei Darussalam" },
	{ code: "BG", codeLowercase: "bg", label: "Bulgaria", hasStripe: true, hasCommissions: true },
	{ code: "BF", codeLowercase: "bf", label: "Burkina Faso" },
	{ code: "BI", codeLowercase: "bi", label: "Burundi" },
	{ code: "KH", codeLowercase: "kh", label: "Cambodia" },
	{ code: "CM", codeLowercase: "cm", label: "Cameroon" },
	{ code: "CA", codeLowercase: "ca", label: "Canada", hasStripe: true, hasCommissions: true },
	{ code: "CV", codeLowercase: "cv", label: "Cape Verde" },
	{ code: "KY", codeLowercase: "ky", label: "Cayman Islands" },
	{ code: "CF", codeLowercase: "cf", label: "Central African Republic" },
	{ code: "TD", codeLowercase: "td", label: "Chad" },
	{ code: "CL", codeLowercase: "cl", label: "Chile" },
	{ code: "CN", codeLowercase: "cn", label: "China" },
	{ code: "CX", codeLowercase: "cx", label: "Christmas Island" },
	{ code: "CC", codeLowercase: "cc", label: "Cocos (Keeling) Islands" },
	{ code: "CO", codeLowercase: "co", label: "Colombia" },
	{ code: "KM", codeLowercase: "km", label: "Comoros" },
	{ code: "CG", codeLowercase: "cg", label: "Congo" },
	{ code: "CD", codeLowercase: "cd", label: "Congo, the Democratic Republic of the" },
	{ code: "CK", codeLowercase: "ck", label: "Cook Islands" },
	{ code: "CR", codeLowercase: "cr", label: "Costa Rica" },
	{ code: "CI", codeLowercase: "ci", label: "Côte d'Ivoire" },
	{ code: "HR", codeLowercase: "hr", label: "Croatia", hasStripe: true, hasCommissions: true },
	{ code: "CU", codeLowercase: "cu", label: "Cuba" },
	{ code: "CW", codeLowercase: "cw", label: "Curaçao" },
	{ code: "CY", codeLowercase: "cy", label: "Cyprus", hasStripe: true, hasCommissions: true },
	{ code: "CZ", codeLowercase: "cz", label: "Czech Republic", hasStripe: true, hasCommissions: true },
	{ code: "DK", codeLowercase: "dk", label: "Denmark", hasStripe: true, hasCommissions: true },
	{ code: "DJ", codeLowercase: "dj", label: "Djibouti" },
	{ code: "DM", codeLowercase: "dm", label: "Dominica" },
	{ code: "DO", codeLowercase: "do", label: "Dominican Republic" },
	{ code: "EC", codeLowercase: "ec", label: "Ecuador" },
	{ code: "EG", codeLowercase: "eg", label: "Egypt" },
	{ code: "SV", codeLowercase: "sv", label: "El Salvador" },
	{ code: "GQ", codeLowercase: "gq", label: "Equatorial Guinea" },
	{ code: "ER", codeLowercase: "er", label: "Eritrea" },
	{ code: "EE", codeLowercase: "ee", label: "Estonia", hasStripe: true, hasCommissions: true },
	{ code: "ET", codeLowercase: "et", label: "Ethiopia" },
	{ code: "FK", codeLowercase: "fk", label: "Falkland Islands (Malvinas)" },
	{ code: "FO", codeLowercase: "fo", label: "Faroe Islands" },
	{ code: "FJ", codeLowercase: "fj", label: "Fiji" },
	{ code: "FI", codeLowercase: "fi", label: "Finland", hasStripe: true, hasCommissions: true },
	{ code: "FR", codeLowercase: "fr", label: "France", hasStripe: true, hasCommissions: true },
	{ code: "GF", codeLowercase: "gf", label: "French Guiana" },
	{ code: "PF", codeLowercase: "pf", label: "French Polynesia" },
	{ code: "TF", codeLowercase: "tf", label: "French Southern Territories" },
	{ code: "GA", codeLowercase: "ga", label: "Gabon" },
	{ code: "GM", codeLowercase: "gm", label: "Gambia" },
	{ code: "GE", codeLowercase: "ge", label: "Georgia" },
	{ code: "DE", codeLowercase: "de", label: "Germany", hasStripe: true, hasCommissions: true },
	{ code: "GH", codeLowercase: "gh", label: "Ghana" },
	{ code: "GI", codeLowercase: "gi", label: "Gibraltar", hasStripe: true, hasCommissions: true },
	{ code: "GR", codeLowercase: "gr", label: "Greece", hasStripe: true, hasCommissions: true },
	{ code: "GL", codeLowercase: "gl", label: "Greenland" },
	{ code: "GD", codeLowercase: "gd", label: "Grenada" },
	{ code: "GP", codeLowercase: "gp", label: "Guadeloupe" },
	{ code: "GU", codeLowercase: "gu", label: "Guam" },
	{ code: "GT", codeLowercase: "gt", label: "Guatemala" },
	{ code: "GG", codeLowercase: "gg", label: "Guernsey" },
	{ code: "GN", codeLowercase: "gn", label: "Guinea" },
	{ code: "GW", codeLowercase: "gw", label: "Guinea-Bissau" },
	{ code: "GY", codeLowercase: "gy", label: "Guyana" },
	{ code: "HT", codeLowercase: "ht", label: "Haiti" },
	{ code: "HM", codeLowercase: "hm", label: "Heard Island and McDonald Islands" },
	{ code: "VA", codeLowercase: "va", label: "Holy See (Vatican City State)" },
	{ code: "HN", codeLowercase: "hn", label: "Honduras" },
	{ code: "HK", codeLowercase: "hk", label: "Hong Kong", hasStripe: true, hasCommissions: true },
	{ code: "HU", codeLowercase: "hu", label: "Hungary", hasStripe: true, hasCommissions: true },
	{ code: "IS", codeLowercase: "is", label: "Iceland" },
	{ code: "IN", codeLowercase: "in", label: "India" },
	{ code: "ID", codeLowercase: "id", label: "Indonesia" },
	{ code: "IR", codeLowercase: "ir", label: "Iran, Islamic Republic of" },
	{ code: "IQ", codeLowercase: "iq", label: "Iraq" },
	{ code: "IE", codeLowercase: "ie", label: "Ireland", hasStripe: true, hasCommissions: true },
	{ code: "IM", codeLowercase: "im", label: "Isle of Man" },
	{ code: "IL", codeLowercase: "il", label: "Israel" },
	{ code: "IT", codeLowercase: "it", label: "Italy", hasStripe: true, hasCommissions: true },
	{ code: "JM", codeLowercase: "jm", label: "Jamaica" },
	{ code: "JP", codeLowercase: "jp", label: "Japan", hasStripe: true, hasCommissions: true },
	{ code: "JE", codeLowercase: "je", label: "Jersey" },
	{ code: "JO", codeLowercase: "jo", label: "Jordan" },
	{ code: "KZ", codeLowercase: "kz", label: "Kazakhstan" },
	{ code: "KE", codeLowercase: "ke", label: "Kenya" },
	{ code: "KI", codeLowercase: "ki", label: "Kiribati" },
	{ code: "KP", codeLowercase: "kp", label: "Korea, Democratic People's Republic of" },
	{ code: "KR", codeLowercase: "kr", label: "Korea, Republic of" },
	{ code: "KW", codeLowercase: "kw", label: "Kuwait" },
	{ code: "KG", codeLowercase: "kg", label: "Kyrgyzstan" },
	{ code: "LA", codeLowercase: "la", label: "Lao People's Democratic Republic" },
	{ code: "LV", codeLowercase: "lv", label: "Latvia", hasStripe: true, hasCommissions: true },
	{ code: "LB", codeLowercase: "lb", label: "Lebanon" },
	{ code: "LS", codeLowercase: "ls", label: "Lesotho" },
	{ code: "LR", codeLowercase: "lr", label: "Liberia" },
	{ code: "LY", codeLowercase: "ly", label: "Libya" },
	{ code: "LI", codeLowercase: "li", label: "Liechtenstein", hasStripe: true, hasCommissions: true },
	{ code: "LT", codeLowercase: "lt", label: "Lithuania", hasStripe: true, hasCommissions: true },
	{ code: "LU", codeLowercase: "lu", label: "Luxembourg", hasStripe: true, hasCommissions: true },
	{ code: "MO", codeLowercase: "mo", label: "Macao" },
	{ code: "MK", codeLowercase: "mk", label: "Macedonia, the Former Yugoslav Republic of" },
	{ code: "MG", codeLowercase: "mg", label: "Madagascar" },
	{ code: "MW", codeLowercase: "mw", label: "Malawi" },
	{ code: "MY", codeLowercase: "my", label: "Malaysia", hasStripe: true },
	{ code: "MV", codeLowercase: "mv", label: "Maldives" },
	{ code: "ML", codeLowercase: "ml", label: "Mali" },
	{ code: "MT", codeLowercase: "mt", label: "Malta", hasStripe: true, hasCommissions: true },
	{ code: "MH", codeLowercase: "mh", label: "Marshall Islands" },
	{ code: "MQ", codeLowercase: "mq", label: "Martinique" },
	{ code: "MR", codeLowercase: "mr", label: "Mauritania" },
	{ code: "MU", codeLowercase: "mu", label: "Mauritius" },
	{ code: "YT", codeLowercase: "yt", label: "Mayotte" },
	{ code: "MX", codeLowercase: "mx", label: "Mexico", hasStripe: true },
	{ code: "FM", codeLowercase: "fm", label: "Micronesia, Federated States of" },
	{ code: "MD", codeLowercase: "md", label: "Moldova, Republic of" },
	{ code: "MC", codeLowercase: "mc", label: "Monaco" },
	{ code: "MN", codeLowercase: "mn", label: "Mongolia" },
	{ code: "ME", codeLowercase: "me", label: "Montenegro" },
	{ code: "MS", codeLowercase: "ms", label: "Montserrat" },
	{ code: "MA", codeLowercase: "ma", label: "Morocco" },
	{ code: "MZ", codeLowercase: "mz", label: "Mozambique" },
	{ code: "MM", codeLowercase: "mm", label: "Myanmar" },
	{ code: "NA", codeLowercase: "na", label: "Namibia" },
	{ code: "NR", codeLowercase: "nr", label: "Nauru" },
	{ code: "NP", codeLowercase: "np", label: "Nepal" },
	{ code: "NL", codeLowercase: "nl", label: "Netherlands", hasStripe: true, hasCommissions: true },
	{ code: "NC", codeLowercase: "nc", label: "New Caledonia" },
	{ code: "NZ", codeLowercase: "nz", label: "New Zealand", hasStripe: true, hasCommissions: true },
	{ code: "NI", codeLowercase: "ni", label: "Nicaragua" },
	{ code: "NE", codeLowercase: "ne", label: "Niger" },
	{ code: "NG", codeLowercase: "ng", label: "Nigeria" },
	{ code: "NU", codeLowercase: "nu", label: "Niue" },
	{ code: "NF", codeLowercase: "nf", label: "Norfolk Island" },
	{ code: "MP", codeLowercase: "mp", label: "Northern Mariana Islands" },
	{ code: "NO", codeLowercase: "no", label: "Norway", hasStripe: true, hasCommissions: true },
	{ code: "OM", codeLowercase: "om", label: "Oman" },
	{ code: "PK", codeLowercase: "pk", label: "Pakistan" },
	{ code: "PW", codeLowercase: "pw", label: "Palau" },
	{ code: "PS", codeLowercase: "ps", label: "Palestine, State of" },
	{ code: "PA", codeLowercase: "pa", label: "Panama" },
	{ code: "PG", codeLowercase: "pg", label: "Papua New Guinea" },
	{ code: "PY", codeLowercase: "py", label: "Paraguay" },
	{ code: "PE", codeLowercase: "pe", label: "Peru" },
	{ code: "PH", codeLowercase: "ph", label: "Philippines" },
	{ code: "PN", codeLowercase: "pn", label: "Pitcairn" },
	{ code: "PL", codeLowercase: "pl", label: "Poland", hasStripe: true, hasCommissions: true },
	{ code: "PT", codeLowercase: "pt", label: "Portugal", hasStripe: true, hasCommissions: true },
	{ code: "PR", codeLowercase: "pr", label: "Puerto Rico" },
	{ code: "QA", codeLowercase: "qa", label: "Qatar" },
	{ code: "RE", codeLowercase: "re", label: "Réunion" },
	{ code: "RO", codeLowercase: "ro", label: "Romania", hasStripe: true, hasCommissions: true },
	{ code: "RU", codeLowercase: "ru", label: "Russian Federation" },
	{ code: "RW", codeLowercase: "rw", label: "Rwanda" },
	{ code: "BL", codeLowercase: "bl", label: "Saint Barthélemy" },
	{ code: "SH", codeLowercase: "sh", label: "Saint Helena, Ascension and Tristan da Cunha" },
	{ code: "KN", codeLowercase: "kn", label: "Saint Kitts and Nevis" },
	{ code: "LC", codeLowercase: "lc", label: "Saint Lucia" },
	{ code: "MF", codeLowercase: "mf", label: "Saint Martin (French part)" },
	{ code: "PM", codeLowercase: "pm", label: "Saint Pierre and Miquelon" },
	{ code: "VC", codeLowercase: "vc", label: "Saint Vincent and the Grenadines" },
	{ code: "WS", codeLowercase: "ws", label: "Samoa" },
	{ code: "SM", codeLowercase: "sm", label: "San Marino" },
	{ code: "ST", codeLowercase: "st", label: "Sao Tome and Principe" },
	{ code: "SA", codeLowercase: "sa", label: "Saudi Arabia" },
	{ code: "SN", codeLowercase: "sn", label: "Senegal" },
	{ code: "RS", codeLowercase: "rs", label: "Serbia" },
	{ code: "SC", codeLowercase: "sc", label: "Seychelles" },
	{ code: "SL", codeLowercase: "sl", label: "Sierra Leone" },
	{ code: "SG", codeLowercase: "sg", label: "Singapore", hasStripe: true },
	{ code: "SX", codeLowercase: "sx", label: "Sint Maarten (Dutch part)" },
	{ code: "SK", codeLowercase: "sk", label: "Slovakia", hasStripe: true, hasCommissions: true },
	{ code: "SI", codeLowercase: "si", label: "Slovenia", hasStripe: true, hasCommissions: true },
	{ code: "SB", codeLowercase: "sb", label: "Solomon Islands" },
	{ code: "SO", codeLowercase: "so", label: "Somalia" },
	{ code: "ZA", codeLowercase: "za", label: "South Africa" },
	{ code: "GS", codeLowercase: "gs", label: "South Georgia and the South Sandwich Islands" },
	{ code: "SS", codeLowercase: "ss", label: "South Sudan" },
	{ code: "ES", codeLowercase: "es", label: "Spain", hasStripe: true, hasCommissions: true },
	{ code: "LK", codeLowercase: "lk", label: "Sri Lanka" },
	{ code: "SD", codeLowercase: "sd", label: "Sudan" },
	{ code: "SR", codeLowercase: "sr", label: "Suriname" },
	{ code: "SJ", codeLowercase: "sj", label: "Svalbard and Jan Mayen" },
	{ code: "SZ", codeLowercase: "sz", label: "Swaziland" },
	{ code: "SE", codeLowercase: "se", label: "Sweden", hasStripe: true, hasCommissions: true },
	{ code: "CH", codeLowercase: "ch", label: "Switzerland", hasStripe: true, hasCommissions: true },
	{ code: "SY", codeLowercase: "sy", label: "Syrian Arab Republic" },
	{ code: "TW", codeLowercase: "tw", label: "Taiwan, Province of China" },
	{ code: "TJ", codeLowercase: "tj", label: "Tajikistan" },
	{ code: "TZ", codeLowercase: "tz", label: "Tanzania, United Republic of" },
	{ code: "TH", codeLowercase: "th", label: "Thailand", hasStripe: true },
	{ code: "TL", codeLowercase: "tl", label: "Timor-Leste" },
	{ code: "TG", codeLowercase: "tg", label: "Togo" },
	{ code: "TK", codeLowercase: "tk", label: "Tokelau" },
	{ code: "TO", codeLowercase: "to", label: "Tonga" },
	{ code: "TT", codeLowercase: "tt", label: "Trinidad and Tobago" },
	{ code: "TN", codeLowercase: "tn", label: "Tunisia" },
	{ code: "TR", codeLowercase: "tr", label: "Turkey" },
	{ code: "TM", codeLowercase: "tm", label: "Turkmenistan" },
	{ code: "TC", codeLowercase: "tc", label: "Turks and Caicos Islands" },
	{ code: "TV", codeLowercase: "tv", label: "Tuvalu" },
	{ code: "UG", codeLowercase: "ug", label: "Uganda" },
	{ code: "UA", codeLowercase: "ua", label: "Ukraine" },
	{ code: "AE", codeLowercase: "ae", label: "United Arab Emirates", hasStripe: true, hasCommissions: true },
	{ code: "GB", codeLowercase: "gb", label: "United Kingdom", hasStripe: true, hasCommissions: true },
	{ code: "US", codeLowercase: "us", label: "United States", hasStripe: true, hasCommissions: true },
	{ code: "UM", codeLowercase: "um", label: "United States Minor Outlying Islands" },
	{ code: "UY", codeLowercase: "uy", label: "Uruguay" },
	{ code: "UZ", codeLowercase: "uz", label: "Uzbekistan" },
	{ code: "VU", codeLowercase: "vu", label: "Vanuatu" },
	{ code: "VE", codeLowercase: "ve", label: "Venezuela, Bolivarian Republic of" },
	{ code: "VN", codeLowercase: "vn", label: "Viet Nam" },
	{ code: "VG", codeLowercase: "vg", label: "Virgin Islands, British" },
	{ code: "VI", codeLowercase: "vi", label: "Virgin Islands, U.S." },
	{ code: "WF", codeLowercase: "wf", label: "Wallis and Futuna" },
	{ code: "EH", codeLowercase: "eh", label: "Western Sahara" },
	{ code: "YE", codeLowercase: "ye", label: "Yemen" },
	{ code: "ZM", codeLowercase: "zm", label: "Zambia" },
	{ code: "ZW", codeLowercase: "zw", label: "Zimbabwe" },
] as const

export default countries
